import { Request } from '@group-devs/yfp7-global-modules'
import {useEffect} from 'react'
import { TopNav, Footer } from '@group-devs/yfp7-global-modules/components/Nav'
import Head from 'next/head'
import ReactGA from 'react-ga';


const request = new Request(process.env.apiDomain)

const Discover = (props) => {
    const site = props.global.site
    const auth = props.global.auth
    const { data: hub } = request.website.swrSite(site.accountId, "HUB")
    const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
    const { data: tracker } = request.insights.swrTracking(site.id)

    console.log('nav',nav);
    
    useEffect(()=>{
        if (tracker)
        {
            if (tracker.ga_id)
            {
                ReactGA.initialize(tracker.ga_id);
                ReactGA.pageview(window.location.pathname + window.location.search);
            }
            if (tracker.matomo_id && tracker.matomoServer)
            {
                var _paq = window._paq = window._paq || [];
                _paq.push(['trackPageView']);
                _paq.push(['enableLinkTracking']);
                (function() {
                    var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
                    _paq.push(['setTrackerUrl', u+'/matomo.php']);
                    _paq.push(['setSiteId', tracker.matomo_id]);
                    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                    g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
                })();
            }
        }
    }, [tracker])

    return (
        <>
            <Head>
                <meta property="og:url" content="dynamic url"/>
                <meta property="og:site_name" content="Discover Shaklee"/>
                <meta property="og:title" content="Discover Shaklee"/>
                <meta property="og:description" content="Discover how to create vitality for life with Shaklee's unique wellness products."/>
                <meta property="og:image" content="../images/discover/img-discover-share01.jpg"/>
                <link rel="shortcut icon" type="image/x-icon" href="../images/discover/img-favicon-ywp01.png"/>
            </Head>
            { nav ? <TopNav auth={auth} host={props.global.host} site={site} navigation={nav.navigation} home={hub.url} /> : null }
            {props.children}
            { nav ? <Footer origin="wellness" host={props.global.host} site={site} navigation={nav.footer_navigation} /> : null }
            <style jsx global>{`
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
                body {
                    font-family: "Montserrat", sans-serif;
                }

                .modal-discover-videos .modal-title {
                    font-size: 18px;
                }

                .modal-discover-videos .player-wrapper {
                    position: relative;
                    padding-top: 56.25%;
                }

                .modal-discover-videos .react-player {
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                @media (min-width: 1200px) { ... }

                @media (min-width: 992px) and (max-width: 1199.98px) { ... }

                @media (min-width: 768px) and (max-width: 991.98px) { ... }

                @media (min-width: 576px) and (max-width: 767.98px) { ... }

                @media (max-width: 575.98px) { ... }

            `}</style>
        </>
    )
}

export default Discover
